import React from 'react'
import graphql from 'graphql'
import Layout from './index'
import { addLocaleData } from 'react-intl'

import messages from '../data/messages/en'
import en from 'react-intl/locale-data/en'
import 'intl/locale-data/jsonp/en'

addLocaleData(en)

export default props => <Layout {...props} i18nMessages={messages} />

export const pageQuery = graphql`
  query LayoutEn {
    site {
      siteMetadata {
        languages {
          defaultLangKey
          langs
        }
      }
    }
    headerLogo: imageSharp(id: { regex: "/main-logo/" }) {
      sizes(maxWidth: 211) {
        ...GatsbyImageSharpSizes
      }
    }
    footerLogo: imageSharp(id: { regex: "/footer-logo/" }) {
      sizes(maxWidth: 211) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/en.js